import { render, staticRenderFns } from "./CTRating.vue?vue&type=template&id=757a031e&scoped=true"
import script from "./CTRating.vue?vue&type=script&lang=js"
export * from "./CTRating.vue?vue&type=script&lang=js"
import style0 from "./CTRating.vue?vue&type=style&index=0&id=757a031e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a031e",
  null
  
)

export default component.exports